import { useEffect, useState, useRef } from "react";
import { Link2, X, Plus, Lock } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const Dependencies = ({ task, boardId, onSave }) => {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [boardTasks, setBoardTasks] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    api.get(`/boards/${boardId}/tasks`).then((r) => setBoardTasks(r.data.filter((t) => t.id !== task.id))).catch(() => {});
  }, [boardId, task.id]);

  useEffect(() => {
    if (!open) return;
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, [open]);

  const blocked = task.blocked_by || [];
  const blockedTasks = blocked.map((id) => boardTasks.find((t) => t.id === id)).filter(Boolean);
  const available = boardTasks.filter((t) => !blocked.includes(t.id));

  return (
    <div data-testid="dependencies-section">
      <label className="text-xs uppercase tracking-wider font-semibold text-zinc-500 flex items-center gap-1.5"><Link2 className="h-3 w-3" /> Bloqueada por</label>
      <div className="flex flex-wrap items-center gap-2 mt-2">
        {blockedTasks.map((t) => (
          <span key={t.id} data-testid={`dependency-${t.id}`} className="flex items-center gap-1.5 text-xs font-medium bg-red-500/10 text-red-300 border border-red-500/20 rounded-full px-2.5 py-1">
            <Lock className="h-3 w-3" /> {t.title}
            {isAdmin && (
              <button onClick={() => onSave({ blocked_by: blocked.filter((x) => x !== t.id) })} data-testid={`remove-dependency-${t.id}`} className="hover:opacity-70"><X className="h-3 w-3" /></button>
            )}
          </span>
        ))}
        <div className="relative" ref={ref}>
          <button onClick={() => setOpen((o) => !o)} data-testid="add-dependency-button"
            className="flex items-center gap-1 text-xs text-zinc-500 hover:text-white border border-dashed border-white/10 rounded-full px-2.5 py-1 transition-colors">
            <Plus className="h-3 w-3" /> dependencia
          </button>
          {open && (
            <div className="absolute top-full mt-1 left-0 z-20 w-64 max-h-48 overflow-y-auto bg-[#1C1C1F] border border-white/10 rounded-xl shadow-xl" data-testid="dependency-dropdown">
              {available.length === 0 && (
                <p className="px-3 py-2.5 text-xs text-zinc-500" data-testid="dependency-empty">
                  No hay otras tareas en este tablero. Crea otra tarea para poder marcarla como dependencia.
                </p>
              )}
              {available.map((t) => (
                <button key={t.id} onClick={() => { onSave({ blocked_by: [...blocked, t.id] }); setOpen(false); }} data-testid={`dependency-option-${t.id}`}
                  className="w-full text-left px-3 py-2 text-sm hover:bg-white/5 truncate">{t.title}</button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
